<template>
  <Flash v-if="showFlash" :alert="flashMessageType">Your practice settings have been saved</Flash>
  
  <div v-if="!editPage">
    <settings-read-only @edit-page="switchPage"></settings-read-only>
  </div>
  <div v-if="editPage">
    <settings @show-flash="handleShowFlash" @edit-page="switchPage"></settings>
  </div>

</template>
<script>

import SettingsReadOnly from "@/components/SettingsReadOnly.vue";
import Settings from "@/components/Settings.vue";
import Flash from "@/components/Flash.vue";


export default {
  components: {
    Settings,
    SettingsReadOnly,
    Flash
  },
  data(){
    return {
      editPage: false,
      showFlash: false,
      flashMessageType: '',
      page: this.$router.currentRoute._value.query.preferences ?? 'practice_details',
      tabActive: [true, false]
    }
  }, methods: {
    switchPage(){
      this.showFlash = false;
      this.editPage = !this.editPage;
    },
     handleShowFlash(){
      this.showFlash = true;
      this.flashMessageType = 'success';
    },
  }
}
</script>